// extracted by mini-css-extract-plugin
export default {"header":"Graph_header__x8HU9","legend":"Graph_legend__dhVK+"};